import PythonApi from '@/services/PythonApi'

export default {
  register(credentials) {
    return PythonApi().post('/auth/register', credentials)
  },
  async login(credentials) {
    return PythonApi().post('/auth/login', credentials)
  },
  async changePassword(passwords) {
    return PythonApi().post('/auth/change-password', passwords)
  }
}



// WEBPACK FOOTER //
// ./src/services/AuthenticationService.js